import './styles/PricingTable.scss';

import { Grid, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import Logo from 'assets/thro-logo.svg';
import { translations } from 'locales/i18n';
import { useLayout } from 'utils/hooks/useLayout';

import PricingSlot from './components/PricingSlot';

interface Props {
  hasUser: boolean;
}

export default function PricingTable(props: Props) {
  const { t } = useTranslation();

  const { setWithoutLayout } = useLayout();

  setWithoutLayout(true);

  return (
    <Grid container direction="column" className="pricing-table">
      <Grid container justifyContent="center">
        <img src={Logo} alt="logo" className="pricing-table__thrologo" />
      </Grid>
      <Grid maxWidth="sm" className="pricing-table__headers" mb={3}>
        <Typography variant="overline" color="textSecondary"></Typography>
        <Typography variant="h3" component="h2" gutterBottom={true}></Typography>
        <Typography
          textAlign={'center'}
          variant="h3"
          component="span"
          color="primary"
          className="pricing-table__mainTitle"
        >
          {t(translations.pages.pricingslots.header())}
        </Typography>
      </Grid>
      <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={2}>
        <Grid item>
          <PricingSlot Payment={false} hideButton={props.hasUser} />
        </Grid>
        <Grid item>
          <PricingSlot Payment={true} hideButton={props.hasUser} />
        </Grid>
      </Grid>
    </Grid>
  );
}
